import * as React from 'react';

var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function SvgTwitterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.135 128h45.831l-100.63 113.303L409.904 395h-92.261l-72.234-93.401L162.713 395h-45.831l106.607-121.184L110.904 128h94.552l65.26 85.322L347.135 128zm-16.041 240.399H356.5L192.105 153.616h-27.3l166.289 214.783z",
    fill: "#FFF"
  }))));
}

export { SvgTwitterIcon as default };
